import api from './api';
import { Campo } from '../components/FichaCadastroGenerico';
import { IOpcao } from '../components/Select';

// Opções do tipinp 'select', gravadas em laytel.funval como 'valor=rotulo;valor=rotulo'
export function lerOpcoes(funval?: string): IOpcao[] {
  return (funval ?? '')
    .split(';')
    .map(par => par.trim())
    .filter(par => par.includes('='))
    .map(par => {
      const posicao = par.indexOf('=');
      return { valor: par.slice(0, posicao).trim(), rotulo: par.slice(posicao + 1).trim() };
    });
}

// Campos de um formulário pelo laytel (GET /layout?tabela=): some vis='0', ordena por ordfic
export async function buscarCamposLayout(tabela: string, signal?: AbortSignal): Promise<Campo[]> {
  const response = await api.get('/layout', { params: { tabela }, signal });

  const layout: any[] = (response.data?.DADOS ?? [])
    .filter((dado: any) => dado?.cam && dado.vis !== '0')
    // Ordem na ficha (laytel.ordfic); campos sem ordem vão para o final
    .sort((dadoA: any, dadoB: any) => {
      const ordemA = dadoA?.ordfic ? Number(dadoA.ordfic) : Number.MAX_SAFE_INTEGER;
      const ordemB = dadoB?.ordfic ? Number(dadoB.ordfic) : Number.MAX_SAFE_INTEGER;
      return ordemA - ordemB;
    });

  return layout.map(dado => ({
    campo: dado.cam,
    label: dado.vis === '1' && dado.cap ? dado.cap : dado.cam,
    lim: dado.lim,
    tipinp: dado.tipinp,
    porfic: dado.porfic,
    obr: dado.obr,
    pre: dado.pre,
    opcoes: dado.tipinp === 'select' ? lerOpcoes(dado.funval) : undefined
  }));
}
